export default "__VITE_ASSET__22982bb3__"